// A prop keeps Trans from replacing the dish name while composing translations.
export const DishFeedbackName = ({ name }: { name: string }) => <strong className="font-semibold">{name}</strong>;
